<script setup>
import { ref } from "vue";

defineProps({
  purgeDate: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["close", "confirm"]);
const isProcessing = ref(false);

// Lógica de Toast interna
const showToast = ref(false);
const toastMessage = ref("");

function resetToastTimeout(duration) {
  return new Promise((resolve) => {
    setTimeout(() => {
      showToast.value = false;
      resolve();
    }, duration);
  });
}

async function showSuccessToast(message) {
  toastMessage.value = message;
  showToast.value = true;
  await resetToastTimeout(2500);
}

// ✅ NOVO: fecha o modal apenas quando não houver ação em andamento.
// Usado pelo clique fora do modal e pelo botão "Manter minha conta".
function handleClose() {
  if (isProcessing.value) return;
  emit("close");
}

async function handleConfirm() {
  if (isProcessing.value) return;
  isProcessing.value = true;

  // Emite o evento passando um callback para o pai avisar quando terminar a API
  emit("confirm", async (success) => {
    if (success) {
      await showSuccessToast("Conta desativada. Você será desconectado...");
      return true;
    } else {
      isProcessing.value = false;
    }
  });
}
</script>

<template>
  <div class="modal-overlay" @click.self="handleClose">
    <div class="modal-content-custom">
      <div class="login-body space-y-4">
        <h3 class="font-bold text-xl text-center">
          Confirmar Exclusão de Conta
        </h3>

        <div
          style="
            background-color: #fff9c4;
            padding: 12px;
            border-radius: 8px;
            margin: 15px 0;
          "
        >
          <p class="text-sm text-justify" style="margin: 0; color: #856404">
            <strong>Atenção:</strong> Você tem até o dia
            <strong>{{ purgeDate }}</strong> para reativar sua conta antes que a
            exclusão seja permanente.
          </p>
        </div>

        <p class="text-sm text-justify">
          <strong>Como reativar:</strong> Se você mudar de ideia, a reativação
          poderá ser feita simplesmente efetuando login em nossa plataforma.
        </p>

        <p class="text-sm text-justify">
          Ao retornar,
          <strong>você manterá todos os seus dados</strong> (textos, notas e
          histórico) e seu plano será automaticamente ajustado para o
          <strong>Plano Free</strong>.
        </p>

        <div class="flex flex-col gap-2 pt-2">
          <button
            @click="handleConfirm"
            class="btn btn-chip-danger-large"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "Processando..." : "Confirmar Exclusão" }}
          </button>

          <button
            @click="handleClose"
            class="btn btn-secondary"
            :disabled="isProcessing"
          >
            Manter minha conta
          </button>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <transition name="toast-fade">
      <div
        v-if="showToast"
        class="fixed inset-0 pointer-events-none z-[100000] flex items-start justify-center pt-6 px-4"
      >
        <div class="toast toast-success pointer-events-auto">
          <div class="toast-content">
            <p class="toast-title">Sucesso!</p>
            <p class="toast-message">{{ toastMessage }}</p>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<style scoped>
.modal-overlay {
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  align-items: flex-start !important;
  justify-content: center !important;
}
.modal-content-custom {
  width: 100%;
  max-width: 26rem;
  background-color: var(--surface) !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--neutral-200);
  overflow: hidden;
}
.login-body {
  padding: 1.5rem;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}

.btn {
  width: 100%;
}
.btn-chip-danger-large {
  background-color: var(--danger-bg);
  color: var(--danger-text);
  border: 1px solid var(--danger-bg);
}
.btn-chip-danger-large:hover:not(:disabled) {
  background-color: var(--danger-bg);
}

</style>